<template>
  <div>
    <!-- 商品集 -->
    <div v-if="addAdvertisingFormat.adFormat == 0" class="originality-cell">
        <CollectionPreview />
        <div class="commodity-main">
          <div class="commodity-cell" v-for="(item, index) in asinsMap" :key="index">
            <el-row>
              <el-col :span="2" class="cell-left">{{ index + 1 }}</el-col>
              <el-col :span="22" v-if="!item.title"></el-col>
              <el-col :span="22" v-else class="selected">
                <div class="img">
                  <gj-image size="60" :src="item.imageUrl"></gj-image>
                </div>
                <div class="main">
                  <gj-tooltip
                    :text-line="1"
                    :content="item.title">
                    {{item.title | defaultShow}}
                  </gj-tooltip>
                  <el-row>
                    <el-col :span="12">
                      <span style="font-weight: 500;">ASIN：</span>{{item.asin | defaultShow}}
                    </el-col>
                    <el-col :span="12">
                      <span style="font-weight: 500;">FBA库存：</span>{{item.fba | defaultShow}}
                    </el-col>
                    <el-col :span="24" style="padding-top: 5px">
                      <span style="font-weight: 500;">MSKU：</span>{{item.msku | defaultShow}}
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
    </div>
    <!-- 视频 -->
    <div v-else class="originality-cell">
        <VideoPreview />
        <div></div>
    </div>
  </div>
</template>

<script>
import CollectionPreview from "modules/ad/sb/ad-add/components/add-originality/collection/ad-preview/ad-preview.vue"
import VideoPreview from "modules/ad/sb/ad-add/components/add-originality/video/ad-preview/ad-preview.vue"
export default {
  name: 'add-originality',
  inject: ['getForms'],
  props: {},
  data() {
    return {
      addAdvertisingFormat: {},
      forms: {},
    };
  },
  components: { CollectionPreview, VideoPreview },
  methods: {},
  computed: {
    asinsMap() {
      let asins = []
      asins[0] = this.forms.asinsItem[0] || {}
      asins[1] = this.forms.asinsItem[1] || {}
      asins[2] = this.forms.asinsItem[2] || {}
      return asins
    }
  },
  created() {
    let { addAdvertisingFormat, creative } = this.getForms()
    this.addAdvertisingFormat = addAdvertisingFormat
    this.forms = creative
  },
};
</script>

<style scoped lang='scss'>
.originality-cell {
  width: 1170px;
  padding-left: 95px;
  display: flex;
  justify-content: space-between;
  >div {
   width: 49%;
  }
}
.commodity-main {
  height: 100%;
  border: 1px solid #eee;
  .commodity-cell {
    line-height: 1;
    height: 74px;
    border-bottom: 1px solid #eee;
    color: #999;
    .cell-left {
      line-height: 74px;
      text-align: center;
      border-right: 1px solid #eee;
    }
    .cell-right {
      cursor: pointer;
      line-height: 74px;
      text-align: center;
      font-size: 18px;
    }
    .selected {
      display: flex;
      height: 74px;
      align-items: center;
      font-size: 12px;
      line-height: 14px;
      color: #666;
      .img {
        padding: 0 12px;
      }
      .main {
        flex: 1;
      }
      .add {
        padding: 0 18px;
        cursor: pointer;
        color: #5d9bfc;
        .opt {
          display: block;
          margin: 0;
        }
      }
      /deep/.el-tooltip {
        margin-bottom: 5px;
      }
    }
    &:last-child {
      border: none;
    }
  }
}
</style>